import crud from '@/crud/form/form'
import resources from '../../resources'
import methods from './methods'
import mounted from './mounted'
import validations from './validations'

export default {
  methods,
  mounted,
  validations,
  resourcePath: '/v1/dweller/rent/parking',
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/form/resources/index.js